import { render, staticRenderFns } from "./FAQS.vue?vue&type=template&id=53225a65&scoped=true&"
import script from "./FAQS.vue?vue&type=script&lang=js&"
export * from "./FAQS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53225a65",
  null
  
)

export default component.exports